import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const contentActionTypes = {
  LOAD: type('[Content] Load'),
  LOAD_SUCCESS: type('[Content] Load Success'),
  LOAD_FAIL: type('[Content] Load Fail'),
};

export class LoadContentAction implements Action {
  readonly type = contentActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadContentSuccessAction implements Action {
  readonly type = contentActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadContentFailAction implements Action {
  readonly type = contentActionTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}



